<template>
    <div>
        <el-table :data="tabledata" :span-method='mergeCols' :border='true'>
            <el-table-column prop="projectId" label="电费项目" min-width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.projectName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="stationId" label="站点" min-width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.stationName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="ammeterId" label="电表号" min-width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.ammeterNo || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="billId" label="计费起始时间" min-width="160" >
                <template slot-scope="{ row }">
                    <span>{{ row.lastRecordTime || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="billId" label="计费终止时间" min-width="160" >
                <template slot-scope="{ row }">
                    <span>{{ row.recordTime || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="billId" label="区间收益" min-width="180">
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.totalProfit) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="billId" label="服务费" min-width="180">
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.needPayAmountTotal) }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from '../../../../src/utils/util'
    export default {
        data() {
            return {
                util: util,
            }
        },
        props:{
            tabledata: {
                default: ()=>{
                    return []
                }
            }
        },
        computed: {
            // 获取所有单元格合并数据
            spanArr() {
                if(!this.tabledata.length) return []
                const mergeCols = ['projectId','stationId','ammeterNo','billId','billId','billId','billId'] // 需要合并的列（字段）
                return util.getMergeCells(this.tabledata, mergeCols, mergeCols)
            }
        },
        methods:{
            // 合并行
            mergeCols ({ row, column, rowIndex, columnIndex }) {
                return this.spanArr[rowIndex][columnIndex]
            },
        }
    }
</script>